/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type OnboardingTeamJoinCreateStep_org = {
    readonly id: string;
    readonly userTeams: {
        readonly __typename: "TeamList";
        readonly list: ReadonlyArray<{
            readonly id: string;
            readonly teamId: string;
            readonly teamName: string;
            readonly createdBy: {
                readonly value: string | null;
            };
            readonly teamCalendarId: string | null;
            readonly settings: {
                readonly __typename: "TeamSettings";
                readonly manageTeamCalendar: boolean;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
            readonly userSettings: {
                readonly __typename: "TeamUserSettings";
                readonly useTeamCalendar: boolean;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
            readonly invitedMembers: ReadonlyArray<{
                readonly addedBy: string | null;
                readonly person: {
                    readonly primaryCalendarId: string;
                    readonly userId: string | null;
                    readonly isYou: boolean;
                    readonly profile: {
                        readonly givenName: string | null;
                        readonly familyName: string | null;
                    } | null;
                    readonly " $fragmentRefs": FragmentRefs<"AvatarPerson_orgPerson">;
                };
            }>;
            readonly teamMembers: ReadonlyArray<{
                readonly addedBy: string | null;
                readonly person: {
                    readonly primaryCalendarId: string;
                    readonly userId: string | null;
                    readonly isYou: boolean;
                    readonly profile: {
                        readonly givenName: string | null;
                        readonly familyName: string | null;
                    } | null;
                    readonly " $fragmentRefs": FragmentRefs<"AvatarPerson_orgPerson">;
                };
            }>;
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $fragmentRefs": FragmentRefs<"TeamJoinCreate_org" | "AvatarRowNew_org">;
    readonly " $refType": "OnboardingTeamJoinCreateStep_org";
};
export type OnboardingTeamJoinCreateStep_org$data = OnboardingTeamJoinCreateStep_org;
export type OnboardingTeamJoinCreateStep_org$key = {
    readonly " $data"?: OnboardingTeamJoinCreateStep_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OnboardingTeamJoinCreateStep_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v2 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "addedBy",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgPerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryCalendarId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isYou",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "givenName",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "familyName",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AvatarPerson_orgPerson"
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "OnboardingTeamJoinCreateStep_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "userTeams",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamName",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Urn",
                                        "kind": "LinkedField",
                                        "name": "createdBy",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "value",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamCalendarId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "settings",
                                        "plural": false,
                                        "selections": [
                                            (v1 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "manageTeamCalendar",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "TeamSettings",
                                                "abstractKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "userSettings",
                                        "plural": false,
                                        "selections": [
                                            (v1 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "useTeamCalendar",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "TeamUserSettings",
                                                "abstractKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TeamMember",
                                        "kind": "LinkedField",
                                        "name": "invitedMembers",
                                        "plural": true,
                                        "selections": (v2 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TeamMember",
                                        "kind": "LinkedField",
                                        "name": "teamMembers",
                                        "plural": true,
                                        "selections": (v2 /*: any*/),
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "TeamList",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamJoinCreate_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AvatarRowNew_org"
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'ad4f2dbe8c8f706095065eaeba398dac';
export default node;
